// 2025/3/21
// shopは互換性のために残している。
// 現在使われているのは store + course

import z from "zod";

const filterSchema = z.object({
  stores: z.array(
    z.object({
      courseIds: z.array(z.number()).optional(),
      id: z.number(),
      staffIds: z.array(z.number().nullable()).optional(),
    }),
  ),
  version: z.number(),
});

export default function getFormParams(): { storeIds?: number[]; courseIds?: number[]; filter?: z.infer<typeof filterSchema>; reservationStartTime?: number } {
  const searchParams = new URLSearchParams(window.location.search);

  const filterStr = searchParams.get("view");
  if (filterStr) {
    console.log(atob(decodeURIComponent(filterStr)));
    const filter = filterSchema.parse(JSON.parse(atob(decodeURIComponent(filterStr))));
    if (filter.version === 2) {
      return { filter, storeIds: filter.stores.map((s) => s.id) };
    }
  }

  const shopIdsStr = searchParams.get("shop");
  const shopIds = shopIdsStr?.split(",").map((shopIdStr) => Number.parseInt(shopIdStr));
  const storeIdsStr = searchParams.get("store");
  const storeIds = storeIdsStr?.split(",").map((storeIdStr) => Number.parseInt(storeIdStr));
  const courseIdsStr = searchParams.get("course");
  const courseIds = courseIdsStr?.split(",").map((courseIdStr) => Number.parseInt(courseIdStr));
  const reservationStartTimeStr = searchParams.get("startAt");
  const reservationStartTime = reservationStartTimeStr ? Number.parseInt(reservationStartTimeStr) : undefined;

  if (shopIds && !courseIds) {
    return { courseIds: [], reservationStartTime, storeIds: shopIds };
  }

  return { courseIds, reservationStartTime, storeIds };
}
